import { createSelector } from 'reselect';

export const selectAddressState = (state: any) => state.address;

export const selectSelectedAddress = createSelector(
  selectAddressState,
  (addressState) => addressState.selectedAddress
);
